import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { MapPin } from 'lucide-react';

export const LandingTopCouponPreview = ({ heroCoupons, onLogin }) => {
  if (heroCoupons.length === 0) return null;
  const coupon = heroCoupons[0];

  return (
    <section className="py-12 md:py-16" data-testid="top-coupon-preview">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <Badge className="bg-red-100 text-red-700 border-red-200 text-sm px-4 py-1 mb-3">Destaque</Badge>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900">O Melhor Desconto do Momento</h2>
        </div>
        <Card className="border-0 shadow-2xl overflow-hidden cursor-pointer hover:shadow-3xl transition-all group"
          onClick={onLogin} data-testid="top-coupon-preview-card">
          <div className="flex flex-col md:flex-row">
            {coupon.images?.length > 0 && (
              <div className="w-full md:w-1/2 aspect-[4/3] md:aspect-auto overflow-hidden">
                <img src={coupon.images[0]} alt={coupon.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
            )}
            <div className={`flex-1 p-6 sm:p-8 md:p-10 flex flex-col justify-center bg-gradient-to-br from-slate-900 to-slate-800 ${!coupon.images?.length ? 'w-full' : ''}`}>
              <div className="flex items-center gap-3 mb-4">
                <span className="bg-red-500 text-white text-2xl sm:text-3xl font-black px-4 py-2 rounded-xl shadow-lg">
                  {coupon.discount_percentage}% OFF
                </span>
                <Badge className="bg-white/10 text-white/80 border-white/20 text-sm">{coupon.category}</Badge>
              </div>
              <h3 className="text-2xl sm:text-3xl font-black text-white mb-3">{coupon.title}</h3>
              <p className="text-base text-slate-300 mb-4 line-clamp-3">{coupon.description}</p>
              <div className="flex items-center gap-2 text-slate-400 text-sm mb-6">
                <MapPin className="h-4 w-4" /> {coupon.city}, {coupon.state}
              </div>
              <Button className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 px-8 rounded-lg text-lg shadow-lg w-fit transition-all transform group-hover:-translate-y-0.5"
                data-testid="top-coupon-preview-btn">
                Quero Este Desconto
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
